<template>
	<div class="default-icon">
		<img v-if="logoSrc" :src="logoSrc" :alt="i.alt" class="default-icon__img" />
		<div v-else-if="iconName" class="default-icon__icon">
			<SvgIcon :icon="iconName" :color="iconClr" />
		</div>
		<div class="default-icon__content">
			<span class="default-icon__label" v-if="l">{{ l }}</span>
			<span class="default-icon__description" v-if="d">{{ d }}</span>
		</div>
	</div>
</template>

<script setup>
const img = useImage();
const { replaceImageSrc } = useImageHelpers();

const props = defineProps({
	fields: { type: Object, required: false },
	rendering: { type: Object, required: false },
	icon: { type: String, required: false },
	iconColor: { type: String, required: false },
	logo: { type: Object, required: false },
	label: { type: String, required: false },
	description: { type: String, required: false },
});

const i = computed(() => props.fields?.logo?.value || props.logo);
const l = computed(() => props.fields?.label?.value || props.label);
const d = computed(() => props.fields?.description?.value || props.description);
const logoSrc = computed(() => {
	if (i.value?.src) {
		return img(replaceImageSrc(i.value.src), { quality: 90 });
	}
	return null;
});

const iconName = computed(() =>
	props.fields?.icon.value ? props.fields.icon.value : props.icon
);
const iconClr = computed(() =>
	props.fields?.iconColor?.value
		? props.fields.iconColor.value
		: props.iconColor
);
</script>

<style lang="scss">
.default-icon {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	padding: 0 8px;
	gap: var(--spacing-05, 4px);

	.default-icon-list--scroll &:not(:last-child) {
		border-right: 1px solid #5c5c5c;
	}

	.default-icon__icon {
		width: 32px;
		height: 32px;
		padding: 0;
		display: block;
	}

	.default-icon__label {
		display: block;
		color: rgba(255, 255, 255, 0.5);
		font-family: var(--primary-font, sans-serif);
		font-size: 14px;
		font-weight: 400;
		line-height: 150%;
	}

	.default-icon__description {
		display: block;
		color: #fff;
		font-family: var(--primary-font, sans-serif);
		font-size: 18px;
		font-weight: 400;
		line-height: 150%;
	}
}
</style>
